import { render, staticRenderFns } from "./MailboxClientSetupView.vue?vue&type=template&id=e1dea9aa&"
import script from "./MailboxClientSetupView.vue?vue&type=script&lang=js&"
export * from "./MailboxClientSetupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1dea9aa')) {
      api.createRecord('e1dea9aa', component.options)
    } else {
      api.reload('e1dea9aa', component.options)
    }
    module.hot.accept("./MailboxClientSetupView.vue?vue&type=template&id=e1dea9aa&", function () {
      api.rerender('e1dea9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/mailbox/MailboxClientSetupView.vue"
export default component.exports